export enum NotificationCategory {
  Classify = 'Classify',
  Send = 'Send',
  BlockedSDR = 'BlockedSDR',
  SdrConversation = 'SdrConversation',
}
